import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { Tree as AntdTree } from "antd";
import { BsFolder, BsSearch, BsTicketPerforated } from "react-icons/bs";
import { FiHardDrive } from "react-icons/fi";
import { StaticFolderEnum } from "../../../utils/enums";

import "./styles.scss";

const props = {
    innerRef: PropTypes.object.isRequired,
    treeData: PropTypes.array.isRequired,
    expandedKeys: PropTypes.array.isRequired,
    folder: PropTypes.object,
    onSelect: PropTypes.func.isRequired,
    onExpand: PropTypes.func.isRequired,
    onResize: PropTypes.func.isRequired,
};

const Tree = ({ innerRef, treeData, expandedKeys, folder, onSelect, onExpand, onResize }) => {
    const { t } = useTranslation();

    const [resizing, setResizing] = useState(false);

    useEffect(() => {
        window.addEventListener("mouseup", mouseUpHandler);

        return () => {
            window.removeEventListener("mouseup", mouseUpHandler);
        };
    }, []);

    useEffect(() => {
        if (resizing) {
            window.addEventListener("mousemove", mouseMoveHandler);
        }

        return () => {
            window.removeEventListener("mousemove", mouseMoveHandler);
        };
    }, [resizing]); // eslint-disable-line

    const mouseUpHandler = () => setResizing(false);

    const mouseMoveHandler = (e) => {
        const { movementX } = e;
        onResize(movementX);
    };

    return (
        <React.Fragment>
            <div className="explorer-tree" ref={innerRef}>
                <div className="tree-box scroll-x scroll-y">
                    <AntdTree
                        showLine
                        showIcon={false}
                        treeData={treeData}
                        selectedKeys={folder ? [folder.key] : []}
                        expandedKeys={expandedKeys}
                        titleRender={(nodeData) => {
                            return (
                                <div className="custom-title">
                                    <span className="icon">
                                        {nodeData.id === StaticFolderEnum.SEARCH_RESULT.id ? (
                                            <BsSearch />
                                        ) : nodeData.id === StaticFolderEnum.ROOT_FOLDER.id ? (
                                            <FiHardDrive />
                                        ) : nodeData.id === StaticFolderEnum.TICKETS.id ? (
                                            <BsTicketPerforated />
                                        ) : (
                                            <BsFolder />
                                        )}
                                    </span>
                                    <span className="title">
                                        {nodeData.title === "root"
                                            ? `${t("drive")} (${nodeData.owner})`
                                            : nodeData.title}
                                    </span>
                                </div>
                            );
                        }}
                        onSelect={onSelect}
                        onExpand={onExpand}
                    />
                </div>
            </div>
            <div className="tree-resize" onMouseDown={() => setResizing(true)} />
        </React.Fragment>
    );
};

Tree.propTypes = props;

export default Tree;
